import _ from 'lodash';

export function decycle(object: any, replacer?: (value: any) => any) {
  const objects = new WeakMap();

  function derez(value: any, path: string) {
    let oldPath: string | undefined; // The path of an earlier occurance of value
    let newValue: any; // The new object or array
    if (replacer !== undefined) {
      value = replacer(value);
    }

    if (
      typeof value === 'object' &&
      value !== null &&
      typeof value.toJSON === 'function'
    ) {
      value = value.toJSON();
    }

    if (
      typeof value === 'object' &&
      value !== null &&
      !(value instanceof Boolean) &&
      !(value instanceof Date) &&
      !(value instanceof Number) &&
      !(value instanceof RegExp) &&
      !(value instanceof String)
    ) {
      oldPath = objects.get(value);
      if (oldPath !== undefined) {
        return { $ref: oldPath };
      }

      objects.set(value, path);

      if (Array.isArray(value)) {
        newValue = [];
        value.forEach(function (element, i) {
          newValue[i] = derez(element, path + '.' + i);
        });
      } else {
        newValue = {};
        Object.keys(value).forEach(function (name) {
          newValue[name] = derez(value[name], path + '.' + name);
        });
      }
      return newValue;
    }
    return value;
  }

  return derez(object, '$');
}

export function retrocycle(data: any) {
  function rez(value: any) {
    if (value && typeof value === 'object') {
      if (Array.isArray(value)) {
        value.forEach(function (element, i) {
          if (typeof element === 'object' && element !== null) {
            const path = element.$ref;
            if (typeof path === 'string') {
              if (path === '$') {
                value[i] = data;
              } else {
                value[i] = _.get(data, path.slice(2));
              }
            } else {
              rez(element);
            }
          }
        });
      } else {
        Object.keys(value).forEach(function (name) {
          const item = value[name];
          if (typeof item === 'object' && item !== null) {
            const path = item.$ref;
            if (typeof path === 'string') {
              if (path === '$') {
                value[name] = data;
              } else {
                value[name] = _.get(data, path.slice(2));
              }
            } else {
              rez(item);
            }
          }
        });
      }
    }
  }

  rez(data);
  return data;
}

export function jsonEncode(
  object: any,
  replacer?: (value: any) => any,
  space?: string | number
) {
  return JSON.stringify(decycle(object, replacer), undefined, space);
}

export function jsonDecode(jsonString: string): any {
  const data = JSON.parse(jsonString);
  return retrocycle(data);
}
